import React, { ReactNode } from "react";
import Image from "next/image";

const AuditCard = ({}) => {
  return (
    <div className={`relative max-w-[40rem] lg:min-w-[25rem]`}>
      {/* Shadow card */}
      <div
        className={`absolute left-[-5px] top-[1px] z-0 h-full w-full rotate-[-2deg] rounded-2xl border-2 border-primary lg:left-[-1.5rem] lg:top-[2px] lg:rotate-[-5deg]`}
      />

      {/* Main card */}
      <div
        className={`relative z-10 h-full w-full rounded-2xl bg-background shadow-[0_0_35px_5px_#BB84FF] overflow-hidden`}
      >
        <div className="overflow-hidden ">
          <Image
            src="/audit.png"
            alt="Bug"
            width={1000}
            height={1000}
            className="h-[120%] w-[120%] object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default AuditCard;
